import React from 'react';
import { useTranslator } from 'tradera-lang/translate';

const SimpleToast = ({ lokaliseKey }) => {
    const { t } = useTranslator();

    return <span>{t(lokaliseKey)}</span>;
};

export default SimpleToast;
